import {useMutation} from "@tanstack/react-query";

import {addSupplierContactMutationOptions} from "./add-supplier-contact.mutation-options";

export function useAddSupplierContact(supplierId: string) {
  return useMutation(addSupplierContactMutationOptions(supplierId));
}
